// Chequeo de roles sobre el profile (MOOV-5198). Los computeds de
// utils.mixin.js delegan acá; los componentes siguen usando isSuperAdmin etc.
export function hasRole(profile, ...roleNames) {
  return roleNames.some(name => profile.roles.findIndex(x => x.name === name) !== -1)
}
